/**
 * Avisos da tela de login que vêm de fora do formulário: o código no
 * `?error=` (o `requireUser` manda o cadastro desativado para cá) e o erro do
 * Supabase Auth para a conta bloqueada (o `ban` que o Desativar põe). Sem
 * `server-only`: a tela de login é do cliente.
 */

/** Código do aviso do cadastro desativado. */
export const INACTIVE_LOGIN_ERROR = "acesso-desativado";

const MESSAGES: Record<string, string> = {
  [INACTIVE_LOGIN_ERROR]:
    "Seu acesso foi desativado. Fale com o administrador da sua empresa.",
};

/** O texto do `?error=`: o aviso conhecido, ou o próprio texto de sempre. */
export function loginErrorFromQuery(value: string | null): string | null {
  if (!value) return null;
  return MESSAGES[value] ?? value;
}

/** O erro do login em português quando é a conta bloqueada. */
export function loginErrorMessage(message: string | null | undefined): string {
  if (message && /banned/i.test(message)) return MESSAGES[INACTIVE_LOGIN_ERROR];
  return message || "Não foi possível entrar. Tente novamente.";
}
